import {TrackInfo} from "./model/track-info";

export class TrackUtil{
    
    public static rebuildTracks(pageId, track, originalTrack): TrackInfo[] {
        const trackIndex = track.findIndex(r => r.pageId === pageId)
        track = track.slice(0, trackIndex + 1);
        const indiceNovo = originalTrack.findIndex(r => r.pageId === pageId);
        if (indiceNovo>-1) {
            track.push(...originalTrack.slice(indiceNovo));
        }
        return track;
    }
    
}